import { render, staticRenderFns } from "./OrderApproal.vue?vue&type=template&id=4222377a&scoped=true&"
import script from "./OrderApproal.vue?vue&type=script&lang=js&"
export * from "./OrderApproal.vue?vue&type=script&lang=js&"
import style0 from "./OrderApproal.vue?vue&type=style&index=0&id=4222377a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4222377a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDialog,VRow,VSelect,VSimpleTable,VSpacer})
